import { AxiosResponse } from 'axios';

export const isResponseUnsuccessful = (response: AxiosResponse<any, any>) => {
  return response.status >= 300;
};
